export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="64" height="64" rx="12" fill="#0C0D0E" />
    <rect x="5" y="5" width="54" height="54" rx="9" fill="none" stroke="#FFC700" strokeWidth="4" />
    <g fill="#FFC700">
      <rect x="13" y="19" width="9" height="9" rx="2" />
      <rect x="25" y="19" width="9" height="9" rx="2" />
      <rect x="37" y="19" width="9" height="9" rx="2" />
      <rect x="42" y="34" width="9" height="9" rx="2" transform="translate(7 -15)" />
      <rect x="13" y="34" width="9" height="9" rx="2" />
      <rect x="25" y="34" width="9" height="9" rx="2" />
      <rect x="37" y="34" width="9" height="9" rx="2" />
      <rect x="42" y="34" width="9" height="9" rx="2" />
    </g>
  </svg>
);

export const LogoWord = ({ className = "" }) => (
  <span className={`font-display font-bold uppercase tracking-wide text-xl leading-none ${className}`}>
    <span className="text-[#F9FAFB]">Stock</span>
    <span className="text-[#FFC700]">box 8</span>
  </span>
);
